<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1 v-if="authenticationPhone && !loading">Hi, let's get you set up</h1>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <section id="mainContent" class="content row column" v-if="authenticationPhone && !loading" key="phone-present">
        <h2>Your phone number</h2>
        <p>To help keep both you and BT secure, we need a phone number we can call or text you on to check it's you when
          you're using Workplace on a personal PC or mobile. The number should be for a device you'll have to hand when
          you sign in to Workplace. This is known as 'Multi Factor Authentication'.</p>
        <p><strong>Note</strong> - We're using a Microsoft service to provide our multi-factor authentication. The number
          you provide will not be shared with Facebook. For more information <a href="/faqs">visit our FAQs</a>.</p>
        <p>We've got your number down as {{ authenticationPhone }}. Shall we call or text you on that number?</p>

        <form ref="fbphonemfa" v-on:submit.prevent="submit" id="fb-phone-mfa" novalidate data-abide>
          <div class="radio">
            <input v-model="authenticationMethod" class="radio-input" type="radio" name="phone-option" id="yes-text"
              value="text" required />
            <label class="radio-label" for="yes-text">Yes, send me codes via text on {{ authenticationPhone }}</label>
          </div>
          <div class="radio">
            <input v-model="authenticationMethod" class="radio-input" type="radio" name="phone-option" id="yes-call"
              value="call" />
            <label class="radio-label" for="yes-call">Yes, call me on {{ authenticationPhone }}</label>
          </div>
          <div class="radio">
            <input class="radio-input" type="radio" name="phone-option" id="no" value="no" />
            <label class="radio-label" for="no">No, I want to choose a different number instead</label>
          </div>
          <p class="button-holder">
            <button class="button" :disabled="submitted" type="submit">Set my number</button>
          </p>
        </form>
      </section>
      <section class="content" v-if="!authenticationPhone || loading" key="loading">
        <img class="loading" src="/static/images/ajax-loader.gif">
      </section>
    </transition>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import api from '../../api'
import authentication from '../../authentication'
import { parsePhoneNumberFromString, isSupportedCountry, getCountryCallingCode, getNumberType } from 'libphonenumber-js'
import router from '../../router'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

export default {
  name: 'PhoneNumber',
  title: 'Workplace - Set your phone number',
  data: function () {
    return {
      authenticated: false,
      user: "",
      authenticationPhone: "",
      authenticationMethod: "",
      currentAuthenticationMethod: "",
      currentAuthenticationPhone: "",
      countryCode: "",
      loading: false,
      submitted: false
    };
  },
  methods: {
    formatPhoneNumber: function () {
      let phoneNumber = parsePhoneNumberFromString(this.authenticationPhone, this.countryCode)
      if (phoneNumber) {
        if (phoneNumber.isValid()) {
          return `+${phoneNumber.countryCallingCode} ${phoneNumber.nationalNumber}`
        }
      }
      return null
    },
    submit: function (event) {
      // Check that we're not double clicking
      if (this.submitted) {
        return;
      }
      this.submitted = true;
      // Check there's no error fields visible...
      const formEl = document.getElementById('fb-phone-mfa')
      if ($(formEl).find('.form-error.is-visible').length || $(formEl).find('.is-invalid-label').length) {
        // Re-enable the button
        this.submitted = false;
        return false;
      }
      this.loading = true;
      const selectedValue = document.querySelector('input[name="phone-option"]:checked').value;

      if (selectedValue === 'no') {
        router.push({ path: 'enter-phone-number', query: { countryCode: this.countryCode } });
      }
      else {
        const phoneNumber = this.formatPhoneNumber()

        if (!authentication.getCachedToken()) {
          localStorage.authenticationMethod = this.authenticationMethod;
          localStorage.authenticationPhone = this.authenticationPhone;
          localStorage.currentAuthenticationMethod = this.currentAuthenticationMethod;
          localStorage.currentAuthenticationPhone = this.currentAuthenticationPhone;
          localStorage.countryCode = this.countryCode;
          authentication.acquireTokenRedirect();
        } else {
          var mfaUpdated = this.authenticationPhone !== this.currentAuthenticationPhone || this.authenticationMethod !== this.currentAuthenticationMethod
          authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.submitAuthentication(phoneNumber, this.authenticationMethod, token, mfaUpdated)
            .then(response => {
              router.push({ path: "done", query: { claimLink: response.data.claimLink, workplaceTenant: response.data.workplaceTenant, authenticationPhone: phoneNumber, authenticationMethod: this.authenticationMethod, completionState: response.data.completionState } });
            })
            .catch(error => {
              console.error(error)
              router.push(this.getErrorRedirect(error))
            });
          });
        }
      }
    },
    getCurrentUser: function () {
      if (!authentication.getCachedToken()) {
        authentication.acquireTokenRedirect()
      }

      if (localStorage.authenticationMethod && localStorage.authenticationPhone && localStorage.countryCode) {
        this.authenticationMethod = localStorage.authenticationMethod;
        this.authenticationPhone = localStorage.authenticationPhone;
        this.currentAuthenticationMethod = localStorage.currentAuthenticationMethod;
        this.currentAuthenticationPhone = localStorage.currentAuthenticationPhone;
        if (this.countryCode) { this.countryCode = localStorage.countryCode; }
        this.removePortalLocalStorage()
      } else {
        authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.getUserDetails(token)
            .then(response => {
              if (response.data.claimLink) {
                console.log("Claim link returned from API, routing to done page")
                this.removePortalLocalStorage();
                router.push({ path: "done", query: { claimLink: response.data.claimLink, completionState: response.data.completionState } });
              } else {
                var suggestedPhoneNumber = this.getBestGuessPhoneNumber(response.data)
                if (!suggestedPhoneNumber) {
                  router.push({ path: 'enter-phone-number', query: { countryCode: response.data.countryCode } });
                } else {
                  this.authenticationPhone = suggestedPhoneNumber;
                  this.authenticationMethod = response.data.defaultAuthenticationMethod || 'text';
                  this.currentAuthenticationMethod = response.data.defaultAuthenticationMethod;
                  this.currentAuthenticationPhone = response.data.authenticationPhone;
                  this.countryCode = response.data.countryCode;
                }
              }
            })
            .catch(error => {
              console.error(error);
              router.push(this.getErrorRedirect(error))
            });
        });
      }
    },
    getBestGuessPhoneNumber(userData) {
      var phoneNumber = null;

      if (userData) {
        if (this.canBeSuggested(userData.authenticationPhone)) {
          phoneNumber = userData.authenticationPhone;
        } else if (this.canBeSuggested(userData.mobilePhone)) {
          phoneNumber = userData.mobilePhone;
        } else if (this.canBeSuggested(userData.phoneNumber)) {
          phoneNumber = userData.phoneNumber;
        }
      }

      return phoneNumber;
    },
    canBeSuggested: function (phoneNumber) {
      return phoneNumber && getNumberType(phoneNumber) === 'MOBILE';
    },
    removePortalLocalStorage: function () {
      localStorage.removeItem('authenticationMethod');
      localStorage.removeItem('authenticationPhone');
      localStorage.removeItem('currentAuthenticationPhone');
      localStorage.removeItem('currentAuthenticationMethod');
      localStorage.removeItem('countryCode');
    }
  },
  mounted() {
    this.user = authentication.getUserProfile();
    this.getCurrentUser();
  }
}
</script>

<style scoped>
.loading {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 50px;
}

.button-holder {
  margin-top: 20px;
}

.content {
  min-height: 100px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}</style>